// Date constraints configuration
export const MIN_DATE_WEEKS_IN_FUTURE = 4;

/**
 * Get the minimum allowed date for date inputs
 * @param weeksInFuture - Number of weeks in the future (default: 2)
 * @returns Date string in YYYY-MM-DD format
 */
export function getMinDate(weeksInFuture: number = MIN_DATE_WEEKS_IN_FUTURE): string {
  const now = new Date();
  const minDate = new Date(now.getTime() + (weeksInFuture * 7 * 24 * 60 * 60 * 1000));
  return minDate.toISOString().split('T')[0];
}

/**
 * Check if a date is valid (not in the past relative to minimum allowed date)
 * @param dateString - Date string to validate
 * @param weeksInFuture - Number of weeks in the future (default: 2)
 * @returns boolean indicating if date is valid
 */
export function isValidFutureDate(dateString: string, weeksInFuture: number = MIN_DATE_WEEKS_IN_FUTURE): boolean {
  if (!dateString) return false;
  const inputDate = new Date(dateString);
  const minDate = new Date(getMinDate(weeksInFuture));
  return inputDate >= minDate;
}